import Reveal from '@/components/feature/Reveal';
import { SectionWrapper, SectionHeading } from '@/components/feature/SectionHeading';
import type { AsaStep } from '@/pages/services/ai-security/content';

interface ProcessSectionProps {
  eyebrow: string;
  title: string;
  steps: AsaStep[];
}

export default function ProcessSection({ eyebrow, title, steps }: ProcessSectionProps) {
  return (
    <SectionWrapper>
      <SectionHeading eyebrow={eyebrow} title={title} />
      <div className="mt-12 md:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {steps.map((step, i) => (
          <Reveal key={step.title} delay={i * 60}>
            <div className="bg-[#1a1a2e] border border-[#2a2a3e] rounded-2xl p-7 h-full relative transition-all duration-300 hover:-translate-y-1 hover:border-[#7c3aed] hover:shadow-[0_0_20px_rgba(124,58,237,0.2)]">
              <div className="text-3xl font-extrabold text-[#a855f7]">{step.step}</div>
              <div className="mt-3 w-10 h-0.5 bg-[#a855f7]"></div>
              <h3 className="mt-4 text-lg font-extrabold text-white">{step.title}</h3>
              <ul className="mt-3 space-y-2">
                {step.items.map((item) => (
                  <li key={item} className="flex items-start gap-2 text-sm text-[#a0a0b0] leading-relaxed">
                    <span className="w-1.5 h-1.5 mt-2 rounded-full bg-[#a855f7]/50 shrink-0"></span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>
    </SectionWrapper>
  );
}